<template>
  <div class="settled-wrapper wrapper_1200">
    <div class="title wrapper_1200">
      <router-link class="home" to="/">{{$t(`userDrawer.data[0].name`)}} ></router-link>
      {{title}}
    </div>
    <div class="settled-main">
      <div class="user-com-title">
        {{title}}
      </div>
      <div class="protocolMain">
        <div class="content">
          <div class="content-main" v-html="content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "contact",
  auth: "guest",
  data() {
    return {
      content: '',
      title: this.$t(`page.index.contactUs`)
    }
  },
  head() {
    return {
      title: this.$t(`page.index.contactUs`)
    }
  },
  beforeMount() {
    this.getContent()
  },
  methods: {
    getContent() {
      let that = this
      that.$axios.get("/api/index/getInfoDetail", {
        params: {
          id: 11
        }
      }).then(res => {
        that.content = res.data.content
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.settled-wrapper {
  .title{
    height: 60px;
    line-height: 60px;
  }
  .settled-main{
    padding: 50px 110px;
    background: #fff;
  }
  .user-com-title {
    font-size: 26px;
    color: #333333;
    text-align: center;
    border: none;
  }
  .content-main{
    color: #333333;
    font-size: 14px;
  }
}
.footer{
  text-align: center;
}
</style>
